"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediabaseDeliveryAgentClips2Schema = void 0;
exports.MediabaseDeliveryAgentClips2Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/mediabase-delivery-agent-clip/2.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "MediabaseDeliveryAgentClips2",
    "description": "Mediabase delivery agent for video preview clips",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:mediabase-delivery-agent-clip:2"
            ]
        },
        "attributes": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "aspectRatios": {
                    "type": "array",
                    "items": {
                        "type": "object",
                        "properties": {
                            "imageURL": {
                                "type": "string",
                                "description": "URL to mediabase clip delivery agent",
                                "format": "uri"
                            },
                            "ratio": {
                                "type": "number",
                                "description": "The calculated ratio, width/height",
                                "minimum": 0
                            },
                            "ratioTextual": {
                                "type": "string",
                                "description": "The cropping ratio in textual form of `{width}x{heigth}`, e.g. 4x3"
                            }
                        },
                        "required": [
                            "imageURL",
                            "ratio",
                            "ratioTextual"
                        ]
                    },
                    "minItems": 1
                }
            },
            "required": [
                "aspectRatios"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMi5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9tZWRpYWJhc2UtZGVsaXZlcnktYWdlbnQtY2xpcC8yLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLGtDQUFrQyxHQUFHO0lBQ2hELEtBQUssRUFBRSxrR0FBa0c7SUFDekcsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsOEJBQThCO0lBQ3ZDLGFBQWEsRUFBRSxrREFBa0Q7SUFDakUsTUFBTSxFQUFFLFFBQVE7SUFDaEIsc0JBQXNCLEVBQUUsS0FBSztJQUM3QixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04sMERBQTBEO2FBQzNEO1NBQ0Y7UUFDRCxZQUFZLEVBQUU7WUFDWixNQUFNLEVBQUUsUUFBUTtZQUNoQixzQkFBc0IsRUFBRSxLQUFLO1lBQzdCLFlBQVksRUFBRTtnQkFDWixjQUFjLEVBQUU7b0JBQ2QsTUFBTSxFQUFFLE9BQU87b0JBQ2YsT0FBTyxFQUFFO3dCQUNQLE1BQU0sRUFBRSxRQUFRO3dCQUNoQixZQUFZLEVBQUU7NEJBQ1osVUFBVSxFQUFFO2dDQUNWLE1BQU0sRUFBRSxRQUFRO2dDQUNoQixhQUFhLEVBQUUsc0NBQXNDO2dDQUNyRCxRQUFRLEVBQUUsS0FBSzs2QkFDaEI7NEJBQ0QsT0FBTyxFQUFFO2dDQUNQLE1BQU0sRUFBRSxRQUFRO2dDQUNoQixhQUFhLEVBQUUsb0NBQW9DO2dDQUNuRCxTQUFTLEVBQUUsQ0FBQzs2QkFDYjs0QkFDRCxjQUFjLEVBQUU7Z0NBQ2QsTUFBTSxFQUFFLFFBQVE7Z0NBQ2hCLGFBQWEsRUFBRSxvRUFBb0U7NkJBQ3BGO3lCQUNGO3dCQUNELFVBQVUsRUFBRTs0QkFDVixVQUFVOzRCQUNWLE9BQU87NEJBQ1AsY0FBYzt5QkFDZjtxQkFDRjtvQkFDRCxVQUFVLEVBQUUsQ0FBQztpQkFDZDthQUNGO1lBQ0QsVUFBVSxFQUFFO2dCQUNWLGNBQWM7YUFDZjtTQUNGO0tBQ0Y7SUFDRCxVQUFVLEVBQUU7UUFDVixZQUFZO1FBQ1osTUFBTTtLQUNQO0NBQ0YsQ0FBQSJ9